import type { IntlShape } from 'react-intl'
import type {
	ReportFormData,
	ReportListItem,
} from 'ui/ManagerFinance/ReportingBase/types'

export const reportForms: Record<string, ReportFormData> = {}

export const reportItems: ReportListItem[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Mittausilmoitukset',
				description: 'Meter forms',
			}),
		key: 'meterForms',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskutushistoria',
				description: 'Invoice history',
			}),
		key: 'invoiceHistory',
		icon: 'description',
	},
]
